import { compareValues } from 'pages/reports/components/ReportFunctions';
import { SortDescriptor } from 'utils/dataQuery';

export interface GridSortChangeEvent {
    sort: SortDescriptor[];
}

/**
 * Creates a sort change handler for Kendo Grid components
 *
 * @param event - The GridSortChangeEvent from Kendo
 * @param sort - Current sort state
 * @param setSort - Function to update sort state
 * @param getSortableValue - Function to extract sortable value from an item
 * @returns void
 */
export const createSortChangeHandler = (
    event: GridSortChangeEvent | any,
    sort: SortDescriptor[],
    setSort: (sort: SortDescriptor[]) => void,
    getSortableValue: (item: any, field?: string) => any
) => {

    // Check if event.sort is an empty array (third click - clear sort)
    if (event.sort && event.sort.length === 0) {

        setSort([]);
        return;

    }

    const field = event.sort?.[0]?.field;
    if (!field) return;

    const current = sort.find(s => s.field === field);
    let nextDir: 'asc' | 'desc' | undefined;

    if (!current)
        nextDir = 'asc'; // default -> asc
    else if (current.dir === 'asc')
        nextDir = 'desc'; // asc -> desc
    else nextDir = undefined; // desc -> default (no sort)

    const makeComparator =
    (f: string, dir: 'asc' | 'desc') => (a: any, b: any) => {

        const cmp = compareValues(getSortableValue(a, f), getSortableValue(b, f));
        return dir === 'desc' ? -cmp : cmp;

    };

    const nextSort = nextDir
        ? [
            {
                compare: makeComparator(field, nextDir),
                dir: nextDir,
                field
            }
        ]
        : [];

    setSort(nextSort);

};
